import { render, staticRenderFns } from "./SkeletonWrapper.vue?vue&type=template&id=7f53dfa3"
import script from "./SkeletonWrapper.vue?vue&type=script&lang=js"
export * from "./SkeletonWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports